import api from './api';

// ─── Patient API ────────────────────────────────────────────────────────────

/**
 * DELETE /api/consultations/appointments/{id}
 * Cancel a CONFIRMED appointment (patient only).
 * Returns 204 on success; throws on failure.
 */
export const cancelAppointment = async (id) => {
  await api.delete(`/consultations/appointments/${id}`);
};

/**
 * GET /api/consultations/appointments/{id}/consultation
 * Fetch read-only consultation result for a patient.
 * Returns ConsultationRecordResponse.
 */
export const getPatientConsultationResult = async (id) => {
  const { data } = await api.get(`/consultations/appointments/${id}/consultation`);
  return data;
};

// ─── Doctor API ─────────────────────────────────────────────────────────────

/**
 * GET /api/doctor/appointments?date=YYYY-MM-DD (optional)
 * Returns DoctorAppointmentResponse[].
 */
export const getDoctorAppointments = async (date) => {
  const params = date ? { date } : {};
  const { data } = await api.get('/doctor/appointments', { params });
  return data || [];
};

/**
 * GET /api/doctor/appointments?startDate=YYYY-MM-DD&endDate=YYYY-MM-DD
 * Used by the schedule calendar to fetch a full month at once.
 * Returns DoctorAppointmentResponse[].
 */
export const getDoctorAppointmentsInRange = async (startDate, endDate) => {
  const { data } = await api.get('/doctor/appointments', { params: { startDate, endDate } });
  return data || [];
};

/**
 * POST /api/doctor/appointments/{id}/consultation
 * Submit consultation record.
 * Body: { patientAttended, existingConditions, analysis, result }
 */
export const submitConsultation = async (id, payload) => {
  const { data } = await api.post(`/doctor/appointments/${id}/consultation`, payload);
  return data;
};

/**
 * POST /api/doctor/appointments/{id}/consultation/documents
 * Upload a document (multipart). documentType: SCAN | REPORT | PRESCRIPTION
 */
export const uploadConsultationDocument = async (id, file, documentType) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('documentType', documentType);
  const { data } = await api.post(
    `/doctor/appointments/${id}/consultation/documents`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
};

/**
 * GET /api/doctor/appointments/{id}/consultation
 * Doctor view of consultation record (read-only + presigned URLs).
 * Returns ConsultationRecordResponse.
 */
export const getDoctorConsultationResult = async (id) => {
  const { data } = await api.get(`/doctor/appointments/${id}/consultation`);
  return data;
};